import { useSelector } from 'react-redux';
import { currentUserRoleIdSelector, isCurrentUserOwner } from 'modules/user/userSlice';
import { allRolesSelector } from 'modules/allUsers/allUsersSlice';

interface UseRoles {
  isAdmin: boolean;
  isOwner: boolean;
  isManager: boolean;
  isUser: boolean;
  userRole: string;
}

const useRoles = (): UseRoles => {
  const allRoles = useSelector(allRolesSelector);
  const currentUserRoleId = useSelector(currentUserRoleIdSelector);
  const currentUserOwner = useSelector(isCurrentUserOwner);

  function checkIsAdmin(): boolean {
    if (allRoles && allRoles.length) {
      const adminRole = allRoles.find(role => role.name === 'Admin');

      if (adminRole && currentUserRoleId) {
        return adminRole.id === currentUserRoleId;
      }
    }
    return false;
  }

  function checkIsManager(): boolean {
    if (allRoles && allRoles.length) {
      const managerRole = allRoles.find(role => role.name === 'Manager');

      if (managerRole && currentUserRoleId) {
        return managerRole.id === currentUserRoleId;
      }
    }
    return false;
  }

  function checkIsUser(): boolean {
    if (allRoles && allRoles.length) {
      const userRole = allRoles.find(role => role.name === 'User');

      if (userRole && currentUserRoleId) {
        return userRole.id === currentUserRoleId;
      }
    }
    return false;
  }

  function getUserRole(): string {
    if (currentUserOwner) {
      return 'Owner';
    }

    if (allRoles && allRoles.length && currentUserRoleId) {
      const role = allRoles.find(role => role.id === currentUserRoleId);

      if (role) {
        return role.name;
      }
    } else if (currentUserRoleId === 'manager') {
      return 'Manager';
    }

    return 'User';
  }

  return {
    isAdmin: checkIsAdmin(),
    isOwner: currentUserOwner,
    isManager: checkIsManager(),
    isUser: checkIsUser(),
    userRole: getUserRole(),
  };
};

export default useRoles;
